<template>
  <Transition name="slide-up">
    <div
      v-if="!hasConsent"
      class="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg"
      role="dialog"
      aria-label="Cookie-Einstellungen"
      aria-live="polite"
    >
      <div class="max-w-6xl mx-auto px-6 py-5">
        <div class="flex flex-col md:flex-row md:items-center gap-4">
          <!-- Text -->
          <div class="flex-1 min-w-0">
            <p class="font-semibold text-dark-900 mb-1">Diese Website verwendet Cookies</p>
            <p class="text-sm text-dark-600 leading-relaxed">
              Wir nutzen Cookies für die Grundfunktionalität der Website.
              <NuxtLink to="/datenschutz" class="text-primary-500 hover:underline">
                Datenschutzerklärung
              </NuxtLink>
            </p>
          </div>

          <!-- Buttons -->
          <div class="flex flex-wrap items-center gap-3 shrink-0">
            <button
              @click="openSettings"
              class="text-sm text-dark-600 hover:text-dark-900 underline underline-offset-2 transition-colors"
            >
              Einstellungen
            </button>
            <button
              @click="acceptNecessary"
              class="px-4 py-2 text-sm border border-gray-300 rounded-lg text-dark-700 hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              Nur notwendige
            </button>
            <button
              @click="acceptAll"
              class="px-5 py-2 text-sm bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-200"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const { hasConsent, acceptAll, acceptNecessary, openSettings, loadConsent } = useCookieConsent()

onMounted(() => {
  loadConsent()
})
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
